import React, { ReactElement, Component, useCallback, useState, useMemo } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Form, Input, Row, Col, Button, Card, notification, /* Tooltip */ } from 'antd';
// import { QuestionCircleFilled } from '@ant-design/icons';
import { LOGIN_URL, pattern, pwdReg, appFactoryPwdReg } from './login-util';
import { http_request_new } from '../../http-worker/http-func';
import { VisibleDelayed } from '../../shared-functions';
import { DrawerDelayedToShowPolicy } from './shared-functions';

// const DrawerDelayedToShow = (props: {
//   drawer_visible: 1 | undefined;
//   set_drawer_visible: React.Dispatch<React.SetStateAction<1 | undefined>>;
//   intl: IntlShape;
// }) => {
//   const handle_info_close = useCallback(() => {
//     props.set_drawer_visible(undefined);
//   }, [props.set_drawer_visible]);

//   return (
//     <Drawer
//       title={props.intl.formatMessage({ id: 'pwd_policy_title' })}
//       placement='bottom'
//       onClose={handle_info_close}
//       visible={!!VisibleDelayedInner(props.drawer_visible)}
//       height={230}
//       headerStyle={{ textAlign: 'center' }}
//       mask={false}
//     >
//       <Typography style={{ width: '400px', margin: '0 auto' }}>
//         <div
//           dangerouslySetInnerHTML={{
//             __html: marked(props.intl.formatMessage({ id: 'pwd_policy' }))
//           }}
//         />
//       </Typography>
//     </Drawer>
//   );
// };

export const Register = injectIntl((props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const { intl, history, non_sso } = props;
  const logo_style = useMemo(() => props.logo_style, [props.logo_style])
  const [form] = Form.useForm();
  const [countdown_register, set_countdown_register] = useState(false);
  const [loading_code, set_loading_code] = useState(false);
  const [disable_send, set_disable_send] = useState(true);
  const [send_success, set_send_success] = useState(false);
  const [drawer_visible, set_drawer_visible]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>();
  const sso_path = useMemo(() => props.sso_path?.replace(/^\//, '') || 'v4.0', [props.sso_path]);

  const onFinish = useCallback(
    async (values) => {
      set_countdown_register(true);
      if (!non_sso) {
        const { username, registrationCode, firstName, lastName, password } = values;
        try {
          const result: any = await http_request_new({
            key: 'auth',
            props: props,
            func: undefined,
            url: `/${sso_path}/users/register`,
            method: 1,
            body: { username, registrationCode, firstName, lastName, password },
            no_refresh: 1
          });
          set_countdown_register(false);
          if (result && !result.code) {
            notification.success({
              message: intl.formatMessage({ id: 'success' }),
              description: intl.formatMessage({ id: 'registered_success' })
            });
            history.push(LOGIN_URL.signIn);
          }
        } catch (err) {
          setTimeout(() => {
            set_countdown_register(false);
          }, 300)
        }
      } else{
        const { username, email, realname, password } = values;
        try {
          const result: any = await http_request_new({
            key: 'auth',
            props: props,
            func: undefined,
            url: `/v1.0/users`,
            method: 1,
            body: { username, email, realname, password },
            no_refresh: 1,
            no_message: 1
          });
          set_countdown_register(false);
          if (!result) {
            notification.success({
              message: intl.formatMessage({ id: 'success' }),
              description: intl.formatMessage({ id: 'registered_success' })
            });
            history.push(LOGIN_URL.signIn);
          }
        } catch (err: any) {
          notification.error({
            message: intl.formatMessage({ id: 'failed' }),
            description: err?.errors[0].message
          });
          setTimeout(() => {
            set_countdown_register(false);
          }, 300)
        }
      }
    },
    [history, props, intl, sso_path, non_sso]
  );

  // const handle_click_info = useCallback(() => {
  //   set_drawer_visible(1);
  // }, []);

  const get_verify_code = useCallback(async () => {
    const { username } = form.getFieldsValue();
    set_loading_code(true);
    const res: any = await http_request_new({
      key: 'registercode',
      props: props,
      url: `/${sso_path}/users/${username}/register-code`,
      method: 0,
      no_refresh: 1,
      custom_warning: (response: any) => {
        const { code, message } = response;
        console.log(response);
        if (code >= 400) {
          notification.warning({
            message: intl.formatMessage({ id: 'warning' }),
            description: message
          });
        }
      }
    });
    if (res && !res.code) {
      set_send_success(true);
      notification.success({
        message: intl.formatMessage({ id: 'success' }),
        description: intl.formatMessage({ id: 'resend_code_success' })
      });
    }
    set_loading_code(false);
  }, [form, props, intl, sso_path]);

  const handleUsernameChange = useCallback((e) => {
    const { value } = e.target;
    set_disable_send(!(typeof value === 'string' && pattern.email.test(value)));
  }, []);

  return (
    <div className='login-register'>
      <Card className='register-content'>
        <Row className="logo-1" style={logo_style ? logo_style : {}}/>
        {/* <div className='logo-2'></div> */}
        <Row className='box-title'>
          <FormattedMessage id='sign_up'></FormattedMessage>
        </Row>
        {
          !non_sso ? 
          <Form form={form} name='register' onFinish={onFinish} scrollToFirstError layout='vertical'>
            <Form.Item
              name='username'
              // label={intl.formatMessage({ id: 'username_email' })}
              rules={[
                { type: 'email', message: intl.formatMessage({ id: 'p_i_username_e' }) },
                { required: true, message: intl.formatMessage({ id: 'p_i_username_e' }) }
              ]}
              validateTrigger={['onBlur']}
            >
              <Input
                placeholder={intl.formatMessage({ id: 'email_address' })}
                onChange={handleUsernameChange}
              />
            </Form.Item>
            <Form.Item shouldUpdate>
              {() => (
                <Button loading={loading_code} disabled={disable_send || send_success} onClick={get_verify_code} type='primary' block>
                  <FormattedMessage id='send_verify_code'></FormattedMessage>
                </Button>
              )}
            </Form.Item>
            <Form.Item
              // className="mt-20"
              name='registrationCode'
              // label={intl.formatMessage({ id: 'verify_code' })}
              rules={[{ required: true, message: intl.formatMessage({ id: 'verify_code' }) }]}
            >
              <Input placeholder={intl.formatMessage({ id: 'verify_code' })} />
            </Form.Item>
            <Form.Item
              name='password'
              required
              hasFeedback
              validateTrigger={['onBlur']}
              // label={
              //   <>
              //     {intl.formatMessage({ id: 'password' })} &nbsp;
              //     <Tooltip title={intl.formatMessage({ id: 'help' })}>
              //       <QuestionCircleFilled style={{ color: '#1890ff' }} onClick={handle_click_info} />
              //     </Tooltip>
              //   </>
              // }
              rules={[
                { required: true, message: intl.formatMessage({ id: 'p_i_password' }) },
                { pattern: pwdReg, message: intl.formatMessage({ id: 'p_c_pwd' }) }
              ]}
            >
              <Input.Password placeholder={intl.formatMessage({ id: 'p_i_n_pwd' })} iconRender={(_: any) => <span/>}/>
            </Form.Item>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item
                  name='firstName'
                  // label={intl.formatMessage({ id: 'first_name' })}
                  rules={[{ required: true, message: intl.formatMessage({ id: 'p_i_first_name' }) }]}
                >
                  <Input placeholder={intl.formatMessage({ id: 'first_name' })} autoComplete='off' />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name='lastName'
                  // label={intl.formatMessage({ id: 'last_name' })}
                  rules={[{ required: true, message: intl.formatMessage({ id: 'p_i_last_name' }) }]}
                >
                  <Input placeholder={intl.formatMessage({ id: 'last_name' })} autoComplete='off' />
                </Form.Item>
              </Col>
            </Row>
            {/* <Row className={'i-agree-text'}>
              <span>
                I agree to the <span className={'primary-link underline'}>Terms of Service</span> and <span className={'primary-link underline'}>Privacy Policy</span>
              </span>
            </Row> */}

            <Form.Item className='mt-20'>
              <Button type='primary' className={'form-submit-button'} htmlType='submit' block loading={countdown_register}>
                {' '}
                <FormattedMessage id='sign_up' />{' '}
              </Button>
            </Form.Item>
            </Form>: <Form form={form} name='register' onFinish={onFinish} scrollToFirstError layout='vertical'>
              <Form.Item
                name='username'
                rules={[
                  { required: true, message: intl.formatMessage({ id: 'please_input' }, {type: intl.formatMessage({id: 'user_name'})}) }
                ]}
                validateTrigger={['onBlur']}
              >
                <Input placeholder={intl.formatMessage({ id: 'user_name' })}/>
              </Form.Item>
              <Form.Item
                name='email'
                rules={[
                  { type: 'email', message: intl.formatMessage({ id: 'p_i_c' }, {name: intl.formatMessage({id: 'email_address'})}) },
                  { required: true, message: intl.formatMessage({ id: 'please_input' }, {type: intl.formatMessage({id: 'email_address'})})}
                ]}
                validateTrigger={['onBlur']}
              >
                <Input
                  placeholder={intl.formatMessage({ id: 'email_address' })}
                  onChange={handleUsernameChange}
                />
              </Form.Item>
              <Form.Item
                name='realname'
                rules={[
                  { required: true, message: intl.formatMessage({ id: 'full_name' }) }
                ]}
                validateTrigger={['onBlur']}
              >
                <Input placeholder={intl.formatMessage({ id: 'full_name' })}/>
              </Form.Item>
              <Form.Item
                name='password'
                required
                hasFeedback
                validateTrigger={['onBlur']}
                rules={[
                  { required: true, message: intl.formatMessage({ id: 'p_i_password' }) },
                  { pattern: appFactoryPwdReg, message: intl.formatMessage({ id: 'p_c_pwd' }) }
                ]}
              >
                <Input.Password placeholder={intl.formatMessage({ id: 'p_i_password' })} iconRender={(_: any) => <span/>}/>
              </Form.Item>
              <Form.Item
                name='confirmpwd'
                required
                hasFeedback
                validateTrigger={['onBlur']}
                dependencies={['password']}
                rules={[
                  { required: true, message: intl.formatMessage({ id: 'please_input' }, {type: intl.formatMessage({id: 'confirm_password'})}) },
                  { pattern: appFactoryPwdReg, message: intl.formatMessage({ id: 'p_i_c' }, {name: intl.formatMessage({id: 'confirm_password'})}) },
                  ({ getFieldValue }) => ({
                    validator(_rule, value) {
                        if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                        }
                        return Promise.reject(intl.formatMessage({ id: 'two_pwd_unequal' }));
                    },
                })
                ]}
              >
                <Input.Password placeholder={intl.formatMessage({ id: 'confirm_password' })} iconRender={(_: any) => <span/>}/>
              </Form.Item>
              <Form.Item className='mt-20'>
                <Button type='primary' className={'form-submit-button'} htmlType='submit' block loading={countdown_register}>
                  {' '}
                  <FormattedMessage id='sign_up' />{' '}
                </Button>
              </Form.Item>
            </Form>
        }
        <Row className='box-footer' align='bottom' justify='center'>
          <div className="divider mb-24" />
          <span
            className='primary-link'
            // className='like-a'
            onClick={() => {
              history.push(LOGIN_URL.signIn);
            }}
          >
            <FormattedMessage id='back_to_login'></FormattedMessage>
          </span>
        </Row>
      </Card>
      {!!VisibleDelayed(drawer_visible) && (
        <DrawerDelayedToShowPolicy {...{ intl, drawer_visible, set_drawer_visible, title: 'pwd_policy_title', height: 230, message: 'pwd_policy' }} />
      )}
    </div>
  );
});
